.clipboard-button {
  align-items: center;
  appearance: none;
  background-color: transparent;
  border: none;
  color: #000;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.875rem;
  font-weight: 500;
  height: 1.5rem;
  justify-content: center;
  outline: none;
  transition: all 0.15s;
  width: 1.5rem;
}

.clipboard-button:focus-visible {
  box-shadow: 0 0 0 0.125rem #000;
  outline: 2px solid #000;
}

.clipboard-button:hover {
  color: #bd0032;
}

.clipboard-button:disabled {
  opacity: 0.5;
  pointer-events: none;
}
